import { defineTheme } from '../utils'

export const terras = defineTheme({
  page: {
    container: 'm-4 border-2 p-8',
    menuSection: 'mb-8 pt-0 md:mt-16 md:border-2',
    heading: 'font-heading text-6xl font-bold uppercase',
  },
  menuTitleBlock: {
    title: 'bg-black p-4 text-center font-heading text-2xl tracking-widest text-white uppercase sm:p-8 sm:text-4xl md:text-6xl lg:-mx-16',
  },
  themeLogo: {
    image: 'hidden',
  },
  menuCategory: {
    title: 'text-3xl italic',
  },
  menuSubCategory: {
    title: 'mb-4 text-secondary italic underline',
    base: 'space-y-4',
  },
  menuItem: {
    dinner: {
      base: 'dinner-base relative z-2 grid grid-cols-[1fr_auto]',
      title: 'text-lg font-bold',
      priceList: 'dinner-price text-right text-lg text-secondary',
      description: 'dinner-description order-2 col-span-2',
      icons: 'menu-icons order-3 mt-1',
    },
    drinks: {
      base: 'dinner-base relative z-2 grid grid-cols-[1fr_auto]',
      title: 'text-lg font-bold uppercase',
      priceList: 'dinner-price text-right text-lg text-secondary',
      description: 'dinner-description order-2 col-span-2',
      icons: 'menu-icons order-3 mt-1',
    },
  },
  languageButton: {
    base: 'rounded border p-2 text-center hover:text-secondary',
  },
  filterBar: {
    bar: 'bg-black text-white',
    barTitle: 'font-normal',
    checkbox: ' accent-white',
    closeButton: 'bg-white text-black hover:bg-white/80',
    masterItem: 'font-normal text-black',
    itemLabel: 'text-black',
    popoverTitle: 'font-normal text-white',
    popover: 'bg-white',
    popoverHeader: 'bg-black',
  },
})
